import http from '../api'
import { MandatoryDisplayDTO } from './types'

async function getMandatoryDisplays() {
  return await http.get<MandatoryDisplayDTO[]>('mandatory-displays')
}

async function createMandatoryDisplay(input: FormData) {
  return await http.post<MandatoryDisplayDTO>('mandatory-displays', input)
}

async function updateMandatoryDisplay(id: number, input: FormData) {
  return await http.patch<MandatoryDisplayDTO>(`mandatory-displays/${id}`, input)
}

async function deleteMandatoryDisplay(id: number) {
  return await http.delete<boolean>(`mandatory-displays/${id}`)
}

export default {
  getMandatoryDisplays,
  createMandatoryDisplay,
  updateMandatoryDisplay,
  deleteMandatoryDisplay,
}
